(() => {
  const selector = '.product-card__title';
  const managedKey = 'productTitleTooltipManaged';
  let frameId = 0;

  const updateTitle = (element) => {
    if (!(element instanceof HTMLElement) || !element.matches(selector)) {
      return;
    }

    // Respect an existing merchant-authored title rather than replacing it.
    if (element.hasAttribute('title') && element.dataset[managedKey] !== 'true') {
      return;
    }

    element.dataset[managedKey] = 'true';
    const label = element.getAttribute('aria-label') || element.textContent.trim();
    const isClipped = element.scrollHeight > element.clientHeight + 1 || element.scrollWidth > element.clientWidth + 1;

    if (isClipped && label) {
      element.setAttribute('title', label);
    } else {
      element.removeAttribute('title');
    }
  };

  const updateAll = () => {
    frameId = 0;
    document.querySelectorAll(selector).forEach(updateTitle);
  };

  const scheduleUpdate = () => {
    if (frameId === 0) {
      frameId = window.requestAnimationFrame(updateAll);
    }
  };

  const init = () => {
    const resizeObserver = 'ResizeObserver' in window
      ? new ResizeObserver((entries) => entries.forEach(({ target }) => updateTitle(target)))
      : null;

    const observeTitles = () => {
      document.querySelectorAll(selector).forEach((element) => {
        updateTitle(element);
        resizeObserver?.observe(element);
      });
    };

    const mutationObserver = new MutationObserver(() => {
      scheduleUpdate();
      window.requestAnimationFrame(observeTitles);
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    observeTitles();

    if (document.fonts?.ready) {
      document.fonts.ready.then(scheduleUpdate);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
